import { defineCustomElement } from 'vue'
import { createPinia } from 'pinia'
import { setupAirbrake } from '@dpgradio/creative'
import { Notifier as AirbrakeNotifier } from '@airbrake/browser'
import App from './App.ce.vue'
import { registerFonts } from './utils/fonts'

const tagName = 'thx-to-you-counter'

if (!customElements.get(tagName)) {
  registerFonts()
  customElements.define(
    tagName,
    defineCustomElement(App, {
      configureApp(app) {
        app.use(createPinia())

        if (import.meta.env.PROD) {
          setupAirbrake(
            AirbrakeNotifier,
            {
              projectId: '<project-id>',
              projectKey: '<project-key>',
              version: import.meta.env.VITE_COMMIT_HASH,
            },
            app
          )
        }
      },
    })
  )
}
